import type { SVGProps } from "react";
import { Ref, forwardRef, memo } from "react";
import { useId } from "react";
/**
 * Can be sized by setting height only
 */
const SvgComponent = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => {
  // Dynamic mask id, sometimes required
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const id = useId();
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={undefined}
      height={18}
      fill="none"
      viewBox="0 0 18 18"
      aria-hidden="true"
      focusable="false"
      ref={ref}
      {...props}
    >
      <path
        fill="currentColor"
        d="M9 1.452A7.544 7.544 0 0 1 16.548 9 7.544 7.544 0 0 1 9 16.548 7.544 7.544 0 0 1 1.452 9 7.544 7.544 0 0 1 9 1.452ZM9 0a9 9 0 1 0 0 18A9 9 0 0 0 9 0Zm0 2.032a6.968 6.968 0 1 0 0 13.936A6.968 6.968 0 0 0 9 2.032ZM9 3.63a1.307 1.307 0 1 1 0 2.613 1.307 1.307 0 0 1 0-2.613Zm4.273 3.557c-1.042.246-2.015.463-2.981.574.03 3.666.447 4.466.909 5.648a.653.653 0 0 1-1.217.475c-.316-.81-.62-1.475-.808-2.85h-.352c-.187 1.373-.49 2.04-.808 2.85a.653.653 0 1 1-1.216-.475c.46-1.181.877-1.98.908-5.648-.966-.111-1.939-.328-2.98-.574a.58.58 0 1 1 .266-1.13c3.509.829 4.51.827 8.012 0a.58.58 0 0 1 .267 1.13Z"
      />
    </svg>
  );
};
const ForwardRef = forwardRef(SvgComponent);
const Memo = memo(ForwardRef);
export default Memo;
